<template>
  <div class="index">
    <div v-if="!isWxWork" class="login">
      <div class="login-card">
        <div class="brand">
          <div class="logo-circle">CM</div>
          <div class="title">Cheers 管理后台</div>
          <div class="subtitle">账号登录</div>
        </div>
        <van-form @submit="handleLogin">
          <van-cell-group inset>
            <van-field v-model="username" name="username" label="账号" placeholder="请输入账号" clearable required />
            <van-field
              v-model="password"
              type="password"
              name="password"
              label="密码"
              placeholder="请输入密码"
              clearable
              required
            />
          </van-cell-group>
          <div class="actions">
            <van-button round block type="primary" native-type="submit" :loading="loading">登录</van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      loading: false
    }
  },
  computed: {
    isWxWork() {
      return navigator.userAgent.toLowerCase().includes('wxwork')
    }
  },
  mounted() {
    if (this.isWxWork) {
      const href = window.location.href
      let code = null
      try {
        const sp = new URL(href).searchParams
        code = sp.get('code')
      } catch (e) {
        console.log(e)
      }
      if (!code) {
        const hashQuery = (window.location.hash || '').split('?')[1] || ''
        const hashParams = new URLSearchParams(hashQuery)
        code = hashParams.get('code')
      }
      if (!code) {
        const m = href.match(/[?&#](?:code)=([^&#]+)/)
        code = m && decodeURIComponent(m[1])
      }
      console.log(code ? `code=${code}` : 'code不存在')
      if (code) {
        this.handleWecomCallback(code)
      } else {
        const base = process.env.VUE_APP_BASE_URL || '/'
        const apiPrefix = base.endsWith('/') ? base : base + '/'
        console.log('6.获取apiPrefix=', apiPrefix)
        window.location.href = apiPrefix + 'wechat-auth'
      }
    }
  },
  methods: {
    async handleWecomCallback(code) {
      try {
        const res = await this.$api.wechatCallback({ code })
        if (res && res.code === 200 && res.data && res.data.token) {
          const userInfo = res.data
          this.$store.dispatch('common/commitUserInfo', userInfo)
          window.localStorage.setItem('access-token', userInfo.token)
          this.$toast('授权成功，正在进入首页')
          this.$router.replace('/home')
          return
        }
        this.$toast((res && res.message) || '授权失败')
      } catch (e) {
        this.$toast('授权失败，请重试')
      }
    },
    async handleLogin() {
      if (!this.username || !this.password) {
        this.$toast('请输入账号和密码')
        return
      }
      this.loading = true
      try {
        const res = await this.$api.login({ username: this.username, password: this.password })
        if (res && res.code === 200 && res.data && res.data.token) {
          // 持久化 token 与用户信息
          const userInfo = res.data
          this.$store.dispatch('common/commitUserInfo', userInfo)
          window.localStorage.setItem('access-token', userInfo.token)
          this.$toast('登录成功')

          // 获取重定向地址
          const redirect = this.$route.query.redirect || '/home'
          this.$router.push(redirect)
        } else {
          this.$toast(res && res.message ? res.message : '登录失败')
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.index {
  min-height: 100vh;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #e6f0ff 100%);
}
.login {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-card {
  width: 92%;
  max-width: 420px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  padding: 20px 20px 24px;
}
.brand {
  text-align: center;
  margin-bottom: 12px;
}
.logo-circle {
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 0 auto 8px auto;
  border-radius: 50%;
  background: #2152ff;
  color: #fff;
  font-weight: 600;
}
.title {
  font-size: 18px;
  font-weight: 600;
}
.subtitle {
  font-size: 14px;
  color: #909399;
  margin-top: 4px;
}
.actions {
  margin: 16px 12px 0;
}
</style>
